export class CodeName {
    constructor(
        public id: number,
        public selected: boolean,
        public readonly code: string,
        public name: string
        ) {
    }
    public findCode: boolean;
    public findName: boolean;

    public clone = (): CodeName => {
        let clone = new CodeName(this.id, this.selected, this.code, this.name);
        clone.findName = this.findName;
        clone.findCode = this.findCode;
        return clone;
    }
}


export class StocksColumnItem extends CodeName {
    constructor(
        id: number,
        selected: boolean,
        code: string,
        name: string,
        public readonly group: string
    ) {
        super(id, selected, code, name)
        this.table = TableGrid.NoSelected;
    }

    public table: TableGrid;

    public clone = (): StocksColumnItem => {
        let clone = new StocksColumnItem(this.id, this.selected, this.code, this.name, this.group);
        clone.findName = this.findName;
        clone.findCode = this.findCode;
        return clone;
    }
}

export enum TableGrid {
    NoSelected = 0,
    View = 1,
    Parameters = 2
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/code-name.ts